var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashOnDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 306,
    viewBox: "0 0 351 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 351,
    height: 306,
    rx: 14,
    fill: "#F2F2F2",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1541_19722",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 49,
    width: 352,
    height: 274
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.56 49H0V323H351.56V49Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1541_19722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.666 138.555V120.745H291.652V138.555H282.094V178.087H265.206V120.745H261.304V105.967L242.38 115.274V120.746H191.085V143.883L146.741 130.643V167.55L78.9129 181.634V130.643H27V266.046H324.153V138.555H296.666Z",
    fill: "url(#paint0_linear_1541_19722)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1131 150.611H45.7943V153.798H72.1131V150.611Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1131 160.254H45.7943V163.441H72.1131V160.254Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1131 170.438H45.7943V173.624H72.1131V170.438Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1131 180.363H45.7943V183.55H72.1131V180.363Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1131 191.715H45.7943V194.901H72.1131V191.715Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1131 201.357H45.7943V204.544H72.1131V201.357Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1131 211.541H45.7943V214.727H72.1131V211.541Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1131 221.465H45.7943V224.651H72.1131V221.465Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.699 160.602H154.596V163.788H186.699V160.602Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.699 170.246H154.596V173.433H186.699V170.246Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.699 180.428H154.596V183.614H186.699V180.428Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.699 190.352H154.596V193.538H186.699V190.352Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.699 201.707H154.596V204.893H186.699V201.707Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.699 211.35H154.596V214.536H186.699V211.35Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.699 221.533H154.596V224.72H186.699V221.533Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.699 231.457H154.596V234.643H186.699V231.457Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.043 197.906H88.5182V201.093H106.043V197.906Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.043 207.551H88.5182V210.737H106.043V207.551Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.043 217.732H88.5182V220.919H106.043V217.732Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.043 227.656H88.5182V230.843H106.043V227.656Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.043 239.012H88.5182V242.198H106.043V239.012Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.661 197.906H112.136V201.093H129.661V197.906Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.661 207.551H112.136V210.737H129.661V207.551Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.661 217.732H112.136V220.919H129.661V217.732Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.661 227.656H112.136V230.843H129.661V227.656Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.661 239.012H112.136V242.198H129.661V239.012Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.027 137.204H198.578V140.391H204.027V137.204Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.027 146.848H198.578V150.034H204.027V146.848Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.027 157.031H198.578V160.218H204.027V157.031Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.027 166.955H198.578V170.142H204.027V166.955Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.027 178.309H198.578V181.495H204.027V178.309Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.027 187.951H198.578V191.138H204.027V187.951Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.027 198.137H198.578V201.323H204.027V198.137Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.027 208.061H198.578V211.247H204.027V208.061Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.627 136.884H214.178V140.07H219.627V136.884Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.627 146.527H214.178V149.714H219.627V146.527Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.627 156.711H214.178V159.898H219.627V156.711Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.627 166.635H214.178V169.821H219.627V166.635Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.627 177.989H214.178V181.175H219.627V177.989Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.627 187.633H214.178V190.82H219.627V187.633Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.627 197.815H214.178V201.001H219.627V197.815Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.627 207.739H214.178V210.925H219.627V207.739Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.851 136.605H229.401V139.792H234.851V136.605Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.851 146.25H229.401V149.437H234.851V146.25Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.851 156.434H229.402V159.62H234.851V156.434Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.851 166.355H229.402V169.542H234.851V166.355Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.851 177.711H229.402V180.897H234.851V177.711Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.851 187.353H229.402V190.54H234.851V187.353Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.851 197.537H229.402V200.723H234.851V197.537Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.851 207.461H229.402V210.647H234.851V207.461Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.712 137.388H247.263V140.574H252.712V137.388Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.712 147.029H247.263V150.216H252.712V147.029Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.712 157.215H247.263V160.401H252.712V157.215Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.712 167.139H247.263V170.325H252.712V167.139Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.712 178.492H247.263V181.679H252.712V178.492Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.712 188.135H247.263V191.321H252.712V188.135Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.712 198.32H247.263V201.507H252.712V198.32Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.712 208.244H247.263V211.431H252.712V208.244Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.326 218.779H198.876V221.966H204.326V218.779Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.325 228.422H198.876V231.608H204.325V228.422Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.926 218.457H214.476V221.644H219.926V218.457Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.925 238.285H214.476V241.472H219.925V238.285Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.149 218.18H229.699V221.366H235.149V218.18Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.149 227.822H229.699V231.009H235.149V227.822Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.149 238.008H229.699V241.194H235.149V238.008Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.01 218.961H247.56V222.148H253.01V218.961Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.01 228.604H247.56V231.79H253.01V228.604Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.01 238.787H247.56V241.974H253.01V238.787Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.554 154.078H286.505V157.265H321.554V154.078Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.555 163.721H286.505V166.908H321.555V163.721Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.555 173.904H286.505V177.091H321.555V173.904Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.555 183.828H286.505V187.015H321.555V183.828Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.554 195.182H286.505V198.368H321.554V195.182Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.555 204.824H286.505V208.011H321.555V204.824Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.554 215.008H286.505V218.194H321.554V215.008Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.554 224.932H286.505V228.118H321.554V224.932Z",
    fill: "#CFDCF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.512 107.562C113.51 107.69 113.481 107.817 113.427 107.934H57.1233C57.3972 106.125 61.6934 104.691 66.9488 104.691C67.6725 104.691 68.379 104.719 69.0582 104.769C69.4674 101.717 72.9892 99.333 77.2715 99.333C80.212 99.333 82.7874 100.455 84.251 102.145C85.5791 101.822 86.9426 101.661 88.3106 101.666C88.3663 101.666 88.4219 101.669 88.4776 101.669C89.2448 98.3926 92.5739 95.9277 96.5656 95.9277C101.125 95.9277 104.82 99.1483 104.82 103.119C104.82 103.774 104.718 104.425 104.516 105.049C104.843 105.038 105.178 105.029 105.518 105.029C109.932 105.029 113.512 106.163 113.512 107.562Z",
    fill: "#E0ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.115 110.77H272.512C273.013 110.418 275.614 110.151 278.748 110.151C278.915 110.151 279.078 110.151 279.24 110.151C278.918 109.544 278.749 108.87 278.748 108.186C278.748 105.458 281.42 103.244 284.714 103.244C287.347 103.244 289.58 104.659 290.37 106.62C290.732 106.582 291.095 106.563 291.459 106.565C291.793 106.565 292.121 106.582 292.44 106.612C292.836 105.787 293.464 105.09 294.249 104.605C295.034 104.119 295.944 103.865 296.872 103.872C297.212 103.872 297.552 103.906 297.885 103.974C298.384 103.133 299.095 102.433 299.948 101.942C300.802 101.45 301.77 101.183 302.759 101.167C303.947 101.198 305.097 101.58 306.059 102.265C307.022 102.949 307.752 103.903 308.155 105.003C308.194 105.003 308.231 104.999 308.27 104.999C311.313 104.999 313.781 107.004 313.781 109.479C313.781 109.719 313.757 109.96 313.71 110.196C314.194 110.168 314.704 110.154 315.231 110.154C317.402 110.151 319.276 110.405 320.115 110.77Z",
    fill: "#E0ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.804 130.495H97.8934C98.2804 130.221 100.298 130.015 102.727 130.015C102.854 130.015 102.982 130.015 103.109 130.015C102.859 129.544 102.728 129.021 102.727 128.491C102.727 126.375 104.798 124.659 107.353 124.659C109.394 124.659 111.125 125.755 111.738 127.276C112.019 127.246 112.301 127.231 112.583 127.232C112.842 127.232 113.096 127.245 113.343 127.268C113.65 126.628 114.137 126.087 114.746 125.71C115.355 125.333 116.061 125.136 116.78 125.141C117.044 125.141 117.307 125.168 117.566 125.221C117.952 124.569 118.503 124.026 119.165 123.645C119.828 123.263 120.578 123.056 121.345 123.044C122.266 123.068 123.158 123.364 123.904 123.895C124.651 124.426 125.217 125.166 125.529 126.019C125.56 126.019 125.588 126.016 125.618 126.016C127.977 126.016 129.891 127.571 129.891 129.49C129.89 129.676 129.872 129.863 129.835 130.046C130.21 130.024 130.606 130.013 131.015 130.013C132.296 129.961 133.578 130.123 134.804 130.495Z",
    fill: "#E0ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.327 95.9279H164.161C164.378 95.393 167.911 94.965 172.233 94.965C173.188 94.965 174.1 94.988 174.954 95.0259C174.814 94.8267 174.737 94.5916 174.732 94.3496C174.732 92.8558 177.771 91.6442 181.517 91.6442C182.154 91.6448 182.79 91.6814 183.423 91.7538C183.353 91.3653 183.317 90.9717 183.315 90.5772C183.315 86.3932 186.979 83 191.502 83C196.024 83 199.685 86.3932 199.685 90.5772V90.5849C199.752 90.581 199.817 90.5772 199.884 90.5772C200.756 90.5762 201.628 90.6477 202.488 90.7909C202.675 86.4656 207.516 83 213.456 83C218.425 83 222.617 85.4183 223.972 88.7354C224.356 88.7123 224.741 88.697 225.137 88.697C226.352 88.6936 227.565 88.8141 228.755 89.0565C229.64 87.8903 230.909 87.0638 232.345 86.719C233.781 86.3743 235.294 86.5328 236.625 87.1673C237.955 87.8019 239.019 88.8728 239.634 90.196C240.249 91.5192 240.376 93.0119 239.994 94.4176C240.581 94.3754 241.19 94.3524 241.819 94.3524C245.282 94.3496 248.228 95.0067 249.327 95.9279Z",
    fill: "#E0ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7942 266.047H324.153",
    stroke: "#CED9EA",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.112 286.12C314.112 287.49 287.523 288.597 254.724 288.597C221.925 288.597 195.336 287.488 195.336 286.12C195.336 284.753 221.925 283.645 254.724 283.645C287.523 283.645 314.112 284.753 314.112 286.12Z",
    fill: "#819DCB",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.713 135.473C246.713 135.473 246.481 138.284 247.498 139.285C248.687 140.453 245.606 146.454 239.203 142.594C232.801 138.734 246.713 135.473 246.713 135.473Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.856 148.892C245.22 151.6 241.918 156.462 241.918 156.462L237.917 152.112C238.079 152 238.208 151.848 238.292 151.671C238.375 151.495 238.41 151.3 238.393 151.105C238.375 150.799 238.337 150.463 238.29 150.104C237.839 147.51 237.22 144.948 236.437 142.432L241.553 139.736L243.487 138.717C243.487 138.717 243.487 139.023 243.513 139.535C243.588 141.447 243.888 143.344 244.407 145.188C244.905 146.806 245.674 148.257 246.856 148.892Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.407 145.19C242.976 146.953 240.74 149.259 238.29 150.104C237.839 147.51 237.22 144.948 236.437 142.432L241.553 139.736L243.513 139.535C243.588 141.448 243.888 143.345 244.407 145.19Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.762 138.357C231.338 139.433 229.549 139.755 227.768 139.074C225.988 138.394 224.887 136.97 225.311 135.896C225.735 134.823 227.524 134.498 229.305 135.178C231.087 135.858 232.183 137.28 231.762 138.357Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.892 136.554C227.892 136.554 226.63 134.51 227.313 130.845C227.996 127.181 227.375 130.635 227.375 130.635L229.964 131.019L227.892 136.554Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.021 135.353C245.723 142.371 240.197 147.346 235.053 147.132C229.909 146.918 227.567 141.697 227.847 134.679V134.662C227.976 131.897 228.847 129.215 230.372 126.89C232.257 124.029 234.893 122.169 237.245 122.265C241.921 122.458 245.592 127.319 245.997 133.467C246.039 134.095 246.046 134.724 246.021 135.353Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.918 133.157L241.686 133.118C241.686 133.118 233.948 136.045 227.848 134.663C227.977 131.898 228.848 129.217 230.373 126.892L240.424 129.023L241.918 133.157Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.751 131.02C239.751 131.636 240.782 134.785 244.491 136.798H246.488L246.717 133.916L239.751 131.02Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05 136.475C250.273 137.609 248.937 138.819 247.059 139.178C245.182 139.537 243.482 138.909 243.258 137.775C243.034 136.641 244.372 135.432 246.249 135.073C248.126 134.714 249.826 135.341 250.05 136.475Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.714 133.916L227.31 130.847C228.86 125.432 232.25 121.415 238.25 121.816C244.967 122.261 246.279 127.276 246.714 133.916Z",
    fill: "#008ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.994 133.01C241.687 133.135 235.393 130.222 230.146 129.141C227.312 128.557 218.516 130.258 218.891 131.075C219.267 131.892 234.644 133.124 240.994 133.01Z",
    fill: "#196AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.642 137.496C235.862 137.496 236.041 137.188 236.041 136.808C236.041 136.428 235.862 136.12 235.642 136.12C235.421 136.12 235.243 136.428 235.243 136.808C235.243 137.188 235.421 137.496 235.642 137.496Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.196 137.496C229.416 137.496 229.595 137.188 229.595 136.808C229.595 136.428 229.416 136.12 229.196 136.12C228.975 136.12 228.796 136.428 228.796 136.808C228.796 137.188 228.975 137.496 229.196 137.496Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.055 133.807C235.461 133.699 235.886 133.681 236.3 133.754C236.714 133.827 237.106 133.989 237.449 134.229",
    stroke: "#01112C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.132 133.646C228.463 133.461 228.837 133.365 229.218 133.368C229.599 133.371 229.972 133.473 230.3 133.664",
    stroke: "#01112C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.332 137.056C231.132 138.225 231.165 139.421 231.431 140.578",
    stroke: "#01112C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.345 142.036L237.356 139.906C237.356 139.906 238.99 142.943 236.248 143.873C233.507 144.803 232.345 142.036 232.345 142.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.594 250.983L297.201 247.641L294.313 254.456L298.905 258.167L303.455 252.074L302.594 250.983Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.045 252.559L310.36 256.165L309.711 256.826L309.556 258.462C309.556 258.462 305.639 274.906 303.288 274.415C302.947 274.346 302.614 274.247 302.292 274.118C299.158 272.858 299.958 269.362 300.674 265.905C301.461 262.129 298.714 257.854 298.714 257.854L302.595 250.984C304.914 251.101 307.216 251.444 309.467 252.008C310.006 252.153 310.533 252.337 311.045 252.559Z",
    fill: "#284A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.045 252.559L310.36 256.164L309.711 256.825L309.556 258.462C309.556 258.462 305.639 274.905 303.288 274.415C302.947 274.346 302.614 274.247 302.292 274.118C303.684 270.871 308.165 260.181 308.089 257.263C308.747 255.568 309.209 253.805 309.467 252.008C310.006 252.153 310.534 252.337 311.045 252.559Z",
    fill: "#40858E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.004 277.778L228.788 269.975L220.922 268.359L218.958 274.08L226.004 277.778Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.004 277.777C225.923 280.102 225.604 282.412 225.052 284.673C224.918 285.166 224.75 285.65 224.551 286.121L220.877 285.514L220.393 284.791L218.535 284.761C218.535 284.761 201.763 281.19 202.223 278.871C202.279 278.586 202.356 278.305 202.454 278.031C203.623 274.754 207.242 275.493 210.815 276.149C214.669 276.854 218.959 274.08 218.959 274.08L226.004 277.777Z",
    fill: "#284A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.052 284.67C224.918 285.163 224.75 285.646 224.551 286.117L220.877 285.51L220.393 284.787L218.535 284.757C218.535 284.757 201.763 281.187 202.223 278.867C202.279 278.582 202.356 278.301 202.454 278.027C205.699 279.646 214.016 283.637 220.679 283.288C220.674 283.291 222.087 284.455 225.052 284.67Z",
    fill: "#40858E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.149 189.464C242.149 189.464 219.609 269.871 218.847 270.62C218.086 271.369 229.272 274.078 229.272 274.078L252.03 207.983C252.03 207.983 259.444 228.931 265.503 234.595C271.562 240.258 295.03 258.194 295.03 258.194L299.599 248.322C299.599 248.322 277.863 231.971 274.175 226.217C270.471 220.439 263.504 185.617 263.504 185.617L242.149 189.464Z",
    fill: "#284A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.74 186.043C249.344 186.896 249.74 202.896 249.74 202.896",
    stroke: "#A9D2D8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.158 186.043C253.09 186.254 253.983 198.803 249.651 198.199",
    stroke: "#A9D2D8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.143 186.043C261.143 186.043 267.554 222.13 272.882 228.248C278.743 234.979 297.701 248.888 297.701 248.888",
    stroke: "#A9D2D8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.317 247.941L294.311 256.772",
    stroke: "#A9D2D8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.631 269.127L229.741 271.998",
    stroke: "#A9D2D8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.61 166.767C237.61 166.767 235.521 170.36 232.885 174.28C232.178 175.331 231.437 176.402 230.68 177.435C230.142 178.166 229.604 178.879 229.071 179.548C227.178 181.928 225.359 183.771 224.079 184.086C220.043 185.083 198.898 174.151 198.898 174.151L202.475 167.717C202.475 167.717 220.261 174.574 221.292 174.373C221.682 174.299 222.629 173.856 223.755 172.197C223.822 172.101 223.884 172.005 223.951 171.904C224.973 170.37 226.115 168.474 227.093 166.649C227.804 165.352 228.435 164.013 228.983 162.641C230.597 158.367 232.259 156.463 232.259 156.463L237.61 166.767Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.885 174.279C232.178 175.33 231.437 176.402 230.68 177.434C230.142 178.165 229.604 178.878 229.071 179.548L223.949 171.904C224.971 170.369 226.113 168.473 227.091 166.648L232.885 174.279Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.752 168.585C237.675 172.364 235.383 176.025 232.885 179.549C230.845 178.014 225.006 172.349 222.966 170.795C224.837 168.03 226.716 165.476 228.418 162.301C229.467 160.216 230.756 158.257 232.259 156.461L239.752 168.585Z",
    fill: "#196AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.872 221.31H176.44L176.924 214.35L178.991 184.5H208.957L209.824 201.149L210.872 221.31Z",
    fill: "#196AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.205 204.068C199.837 204.068 204.402 201.919 204.402 199.268C204.402 196.618 199.837 194.469 194.205 194.469C188.573 194.469 184.008 196.618 184.008 199.268C184.008 201.919 188.573 204.068 194.205 204.068Z",
    fill: "#FFECF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.872 221.309H176.44L176.924 214.35C190.522 214.962 202.551 207.156 209.824 201.148L210.872 221.309Z",
    fill: "#196AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.165 186.768C202.165 186.768 198.795 170.404 193.688 170.627",
    stroke: "#01112C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.625 167.715L201.04 171.159C200.972 171.74 200.779 172.3 200.475 172.803C200.17 173.305 199.761 173.738 199.274 174.073C196.455 174.71 194.893 174.005 194.893 174.005C194.893 174.005 191.474 174.992 190.655 173.731C190.596 173.721 190.538 173.708 190.48 173.693C190.331 173.663 190.188 173.629 190.053 173.59C186.411 172.567 188.433 169.408 190.575 165.142C192.824 160.667 202.625 167.715 202.625 167.715Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.767 169.28C194.009 170.41 191.355 171.643 190.479 173.692C190.329 173.663 190.186 173.629 190.052 173.589C190.416 172.768 190.967 172.041 191.662 171.462C191.439 171.462 191.209 171.467 190.986 171.467C190.6 171.518 190.208 171.503 189.828 171.422C189.792 171.413 189.761 171.392 189.738 171.364C189.716 171.335 189.704 171.3 189.704 171.263C189.704 171.227 189.716 171.192 189.738 171.163C189.761 171.134 189.792 171.114 189.828 171.104C190.235 171.002 190.66 170.986 191.075 171.056C191.403 171.07 191.716 171.104 192.039 171.148C192.347 170.904 192.68 170.674 193.013 170.459C192.642 169.572 192.551 168.595 192.75 167.656C192.79 167.504 193.048 167.534 193.038 167.695C192.932 168.573 193.003 169.462 193.247 170.312C194.028 169.848 194.849 169.454 195.701 169.133C195.798 169.099 195.842 169.236 195.767 169.28Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.916 170.625C187.81 170.848 184.439 186.765 184.439 186.765",
    stroke: "#01112C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.375 186.044L241.588 189.971C241.588 189.971 227.305 161.794 232.199 156.465C234.991 153.428 236.992 152.815 237.858 152.115L241.859 156.465C241.859 156.465 245.162 151.603 246.798 148.895C247.094 149.056 247.418 149.162 247.754 149.205C252.061 149.787 258.173 149.617 259.356 153.69C260.538 157.763 264.375 186.044 264.375 186.044Z",
    fill: "#196AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.809 163.223L247.719 164.4L247.964 165.832L255.055 164.654L254.809 163.223Z",
    fill: "#FFECF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.918 156.461L246.037 148.262C246.037 148.262 248.687 147.764 249.673 149.413C250.658 151.061 250.988 156.202 250.988 156.202C251.198 155.503 245.929 154.611 241.918 156.461Z",
    fill: "#FFECF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.392 151.104L241.917 156.46C241.917 156.46 237.196 156.107 235.222 159.674C235.222 159.674 233.893 151.706 238.392 151.104Z",
    fill: "#FFECF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.269 189.462L265.45 185.616C265.45 185.616 274.598 172.668 274.598 171.242C274.598 170.918 273.708 170.424 272.331 169.855C271.62 169.557 270.775 169.238 269.86 168.91C267.993 168.249 265.819 167.558 263.801 166.941C260.223 165.845 257.133 164.994 257.133 164.994C257.133 164.994 245.651 153.595 257.133 150.996C257.133 150.996 263.961 154.273 270.775 157.97C272.358 158.828 273.941 159.708 275.438 160.574L275.532 160.629C279.897 163.162 283.503 165.569 284.209 166.96C286.2 170.883 270.269 189.462 270.269 189.462Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.532 160.625C274.492 163.513 273.052 167.556 272.332 169.853C271.62 169.556 270.776 169.236 269.86 168.908C267.993 168.247 265.82 167.556 263.801 166.939L266.3 158.503L270.776 157.969C272.358 158.826 273.941 159.706 275.439 160.572L275.532 160.625Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.44 160.574C273.8 163.095 270.894 168.191 269.121 170.793C263.946 168.964 257.135 164.994 257.135 164.994C257.135 164.994 245.653 153.595 257.135 150.996C257.133 150.996 267.504 155.975 275.44 160.574Z",
    fill: "#196AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.308 184.898C267.308 184.898 258.712 184.934 258.099 186.647C257.457 188.44 255.94 194.248 257.177 194.468C258.139 194.639 259.699 189.229 259.699 189.229C259.699 189.229 258.344 195.092 259.204 195.553C260.334 196.16 262.186 189.968 262.186 189.968C262.186 189.968 260.374 196.793 261.816 196.826C263.258 196.859 264.25 191.084 264.25 191.084C264.25 191.084 263.5 196.906 264.435 196.827C265.37 196.747 266.34 192.13 266.34 192.13C266.34 192.13 271.072 191.051 271.684 187.773C272.419 183.844 267.308 184.898 267.308 184.898Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82 286.119C174.82 287.489 149.719 288.595 118.759 288.595C87.7979 288.595 62.6938 287.486 62.6938 286.119C62.6938 284.751 87.7918 283.641 118.756 283.641C149.72 283.641 174.82 284.751 174.82 286.119Z",
    fill: "#819DCB",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.337 182.225L120.354 181.534L121.612 181.342C122.281 181.408 122.898 181.724 123.337 182.225Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.697 142.778C110.4 143.025 110.095 143.261 109.782 143.485C107.21 145.331 104.165 146.513 101.161 147.486C98.7205 148.277 96.0566 149.277 94.829 151.68C93.5358 154.214 94.3708 156.09 95.467 158.447C95.972 159.534 96.2776 160.858 95.6563 161.885C95.2109 162.62 94.3926 163.036 93.6994 163.552C92.8814 164.163 92.2126 164.946 91.7423 165.844C91.272 166.742 91.0121 167.733 90.9817 168.743C90.9512 169.753 91.151 170.757 91.5664 171.681C91.9818 172.605 92.6022 173.426 93.3821 174.084C94.4848 174.923 95.7153 175.587 97.0281 176.049C101.616 177.912 106.431 179.601 111.391 179.46C114.736 179.365 117.997 178.438 121.159 177.36C124.649 176.17 128.174 174.719 130.774 172.137C133.374 169.555 134.861 165.587 133.558 162.185C133.057 160.882 132.166 159.544 132.583 158.213C132.861 157.329 133.652 156.718 134.334 156.082C137.897 152.768 139.096 146.985 136.505 142.89C136.278 142.471 135.934 142.123 135.514 141.888C135.148 141.746 134.758 141.678 134.365 141.687C129.584 141.491 119.871 135.052 115.09 134.855C115.443 134.943 113.805 139.043 113.619 139.366C112.856 140.663 111.867 141.818 110.697 142.778Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.548 134.951C137.966 137.445 136.868 139.896 134.997 141.287C131.459 143.918 120.657 129.725 120.657 129.725C120.612 128.409 121.085 127.127 121.977 126.146C122.921 125.217 124.161 124.635 125.488 124.496C130.676 123.721 138.788 125.581 139.056 128.906C139.182 130.935 139.012 132.971 138.548 134.951Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.044 277.788L131.116 279.641L129.534 273.59L137.931 271.678L139.044 277.788Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.141 285.484C130.394 285.539 130.425 283.327 130.71 281.603C130.823 280.933 130.978 280.272 131.173 279.621L139.05 277.788C139.05 277.788 144.33 277.514 147.926 278.408C149.229 278.732 150.314 279.214 150.843 279.914C152.831 282.545 134.988 285.394 132.141 285.484Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.141 285.484C130.394 285.539 130.425 283.327 130.71 281.603C134.76 281.533 145.824 281.095 147.926 278.408C149.229 278.732 150.314 279.214 150.843 279.914C152.831 282.545 134.988 285.394 132.141 285.484Z",
    fill: "#284A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.931 271.68L129.534 273.592L111.011 202.658L122.688 188.18L137.931 271.68Z",
    fill: "#196AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.534 272.204L137.397 270.279",
    stroke: "#FFECF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.905 273.475C90.8201 276.039 83.521 259.762 82.7121 257.07C82.2272 255.473 84.0855 254.927 85.6772 254.751C86.361 254.677 87.0495 254.652 87.737 254.677L88.2381 254.664L91.9274 261.581C92.7166 264.048 93.2634 266.583 93.5603 269.152C93.7273 270.95 93.6115 272.604 92.905 273.475Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.905 273.475C90.8201 276.04 83.521 259.762 82.7121 257.071C82.2272 255.474 84.0855 254.927 85.6772 254.752C86.9838 258.804 90.0196 266.767 93.5625 269.152C93.7273 270.951 93.6115 272.605 92.905 273.475Z",
    fill: "#284A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3914 250.192L96.6904 257.973C93.8405 260.165 91.9249 261.579 91.9249 261.579L87.3464 254.67C87.3464 254.67 89.4647 252.83 92.3914 250.192Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.315 186.716C121.292 191.87 116.753 198.114 116.753 198.114C116.753 198.114 120.123 229.373 120.87 234.532C121.426 238.378 105.045 251.535 96.6881 257.977L92.3892 250.195C98.9551 244.271 109.579 234.342 109.321 232.312C108.948 229.376 100.48 209.524 99.2618 201.145C97.3812 188.184 106.516 183.663 106.516 183.663L120.354 181.537L123.337 182.228C123.946 182.957 124.266 184.29 123.315 186.716Z",
    fill: "#196AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.213 184.152C108.732 184.065 102.166 188.562 102.359 195.611C102.553 202.659 112.617 230.855 112.23 233.332C111.843 235.809 94.772 251.471 94.772 251.471",
    stroke: "#FFECF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.629 249.469L97.6418 256.496",
    stroke: "#FFECF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.356 184.15C112.323 184.338 109.022 189.256 105.964 186.716",
    stroke: "#FFECF3",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.923 177.962L166.736 184.219C166.736 184.219 143.252 184.102 137.486 181.782C136.061 181.164 134.704 180.403 133.437 179.512C128.005 175.849 121.842 169.855 121.842 169.855L128.656 158.539C128.656 158.539 133.982 166.954 139.058 171.95C140.784 173.649 142.477 174.952 143.926 175.394C149.63 177.135 167.923 177.962 167.923 177.962Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.056 171.95L133.437 179.513C128.005 175.849 121.842 169.855 121.842 169.855L128.656 158.539C128.656 158.539 133.978 166.954 139.056 171.95Z",
    fill: "#233A63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.424 179.547C164.424 179.547 169.29 174.358 173.002 172.823C177.4 171.003 181.722 170.625 181.674 171.381C181.619 172.283 174.827 174.141 174.614 174.371C174.402 174.602 176.689 173.793 178.152 173.69C179.836 173.572 183.441 173.677 183.274 174.219C182.89 175.501 180.569 174.917 178.629 175.323C177.537 175.546 176.459 175.832 175.401 176.18C175.401 176.18 182.655 175.952 182.332 176.826C182.009 177.701 179.882 177.929 178.246 178.009C177.273 178.055 176.303 178.157 175.342 178.315C175.342 178.315 181.901 178.507 181.659 179.39C181.416 180.273 178.22 180.079 177.478 180.18C176.556 180.22 175.672 180.552 174.958 181.127C174.426 181.604 170.665 185.073 166.002 184.101C161.34 183.13 164.424 179.547 164.424 179.547Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.325 174.109C172.508 174.554 171.737 175.078 171.026 175.674C170.233 176.222 169.441 176.77 168.697 177.38C168.631 177.435 168.716 177.536 168.788 177.495C169.79 176.92 170.736 176.25 171.691 175.596C171.904 175.449 172.933 174.527 173.208 174.554C173.974 174.241 174.309 174.365 173.953 175.188L173.792 175.496C173.736 175.839 173.295 176.194 173.084 176.433C172.549 176.927 172.184 177.573 172.04 178.281C171.818 179.651 171.631 181.021 170.135 181.594C169.923 181.676 170.009 182.013 170.232 181.936C171.559 181.48 172.124 180.279 172.314 178.983C172.326 178.494 172.423 178.011 172.603 177.555C172.845 177.189 173.123 176.849 173.434 176.538C173.888 176.051 174.227 175.471 174.426 174.839C174.584 174.063 173.992 173.836 173.325 174.109Z",
    fill: "#008ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.315 186.716L106.516 183.662C106.516 183.662 106.516 165.447 107.653 160.738C108.841 155.819 111.646 154.231 115.58 152.145C119.638 155.024 125.053 159.075 125.902 160.738C126.686 159.44 127.233 158.017 127.516 156.533C128.53 157.74 129.326 159.109 129.872 160.58C131.849 166.448 123.315 186.716 123.315 186.716Z",
    fill: "#284A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.627 153.43C125.898 154.481 126.667 155.434 127.516 156.532C127.233 158.017 126.686 159.44 125.902 160.738C125.053 159.075 119.638 155.023 115.58 152.144C115.785 152.035 115.993 151.925 116.198 151.811C117.812 150.826 119.046 149.338 119.705 147.585C120.157 146.498 120.49 145.367 120.697 144.211C120.808 143.59 120.838 143.2 120.838 143.2L123.208 144.504L128.098 147.204C128.098 147.204 125.448 150.31 125.528 152.757C125.536 152.984 125.569 153.21 125.627 153.43Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.528 152.756C125.536 152.984 125.569 153.21 125.626 153.43C122.337 152.248 120.483 149.186 119.705 147.584C120.158 146.498 120.49 145.367 120.697 144.211L123.208 144.504L128.098 147.204C128.098 147.204 125.448 150.31 125.528 152.756Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.423 171.382C156.423 171.382 136.042 181.622 130.996 181.109C129.125 180.917 125.822 179.6 122.328 177.788C121.452 177.338 120.568 176.852 119.688 176.349C118.137 175.456 116.607 174.502 115.212 173.535C112.024 171.33 109.526 169.072 108.993 167.414C107.57 162.975 109.415 155.175 115.58 156.462C115.58 156.462 118.92 160.29 122.644 164.243C123.56 165.224 124.507 166.212 125.431 167.153C125.582 167.307 125.729 167.46 125.88 167.609C128.729 170.478 131.299 172.793 132.232 172.863C134.735 173.047 153.805 165.832 153.805 165.832L156.423 171.382Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.43 167.158L122.328 177.789C121.452 177.338 120.567 176.852 119.687 176.349C118.136 175.457 116.607 174.502 115.211 173.536L122.643 164.246C123.559 165.228 124.506 166.217 125.43 167.158Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.88 166.87L119.204 178.627C114.109 175.7 109.757 169.798 108.993 167.414C107.57 162.975 109.415 155.175 115.58 156.462C115.58 156.462 121.118 162.07 125.88 166.87Z",
    fill: "#305C7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.261 165.254C171.146 166.374 169.212 166.317 169.043 166.431C168.923 166.509 168.967 166.746 168.683 167.065C168.49 167.265 168.264 167.432 168.015 167.558C166.992 168.114 167.672 168.687 166.819 169.015C166.254 169.2 165.718 169.462 165.227 169.794C163.916 170.525 156.421 171.387 156.421 171.387L152.003 168.009C152.003 168.009 154.679 162.605 157.244 160.898L160.133 161.975C160.133 161.975 160.92 162.128 162.071 162.369C165.282 163.04 171.345 164.431 171.261 165.254Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.26 165.255C171.145 166.375 169.211 166.318 169.042 166.432C168.923 166.511 168.967 166.747 168.682 167.066C166.802 164.953 163.56 163.137 162.072 162.367C165.282 163.041 171.345 164.433 171.26 165.255Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.341 163.837C161.113 163.837 160.198 158.197 160.198 158.197C160.198 158.197 173.138 157.407 176.517 161.372L177.79 167.014C177.79 167.014 172.423 163.751 161.341 163.837Z",
    fill: "#6B9B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.812 158.553C160.812 158.553 173.389 158.213 176.229 161.516L177.275 166.196C172.413 163.916 167.028 162.936 161.659 163.354L160.812 158.553Z",
    fill: "#B4C482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.859 161.267C170.958 162.276 170.463 163.148 169.754 163.216C169.044 163.283 168.388 162.52 168.289 161.511C168.19 160.503 168.685 159.63 169.395 159.563C170.104 159.495 170.76 160.258 170.859 161.267Z",
    fill: "#6B9B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.584 163.403C161.366 163.471 158.798 158.348 158.798 158.348C158.798 158.348 170.922 153.828 175.341 156.632L178.251 161.651C178.251 161.651 172.144 160.096 161.584 163.403Z",
    fill: "#8EB561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.489 158.51C159.489 158.51 171.403 154.525 175.106 156.853L177.511 161.018C172.182 160.254 166.743 160.885 161.74 162.847L159.489 158.51Z",
    fill: "#C9D8A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.905 158.179C170.303 159.113 170.092 160.091 169.435 160.362C168.777 160.633 167.921 160.095 167.523 159.16C167.125 158.225 167.336 157.248 167.994 156.976C168.652 156.705 169.508 157.244 169.905 158.179Z",
    fill: "#8EB561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.249 160.896C159.817 159.191 163.882 159.402 165.377 159.088C166.873 158.774 166.554 161.073 160.136 161.976",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.015 140.077C139.299 141.158 137.995 142.425 136.103 142.907C134.211 143.39 132.447 142.907 132.162 141.824C131.878 140.74 133.181 139.475 135.074 138.993C136.966 138.511 138.73 138.996 139.015 140.077Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.045 151.719C123.906 152.086 118.363 146.842 117.847 139.839C117.618 136.579 118.597 133.347 120.603 130.742C120.723 130.585 120.847 130.432 120.972 130.283C122.83 128.077 125.284 126.647 127.711 126.476C128.671 126.403 129.636 126.551 130.528 126.909C131.42 127.266 132.215 127.824 132.85 128.537C134.325 130.228 135.341 132.258 135.806 134.44C136.132 135.776 136.345 137.137 136.442 138.509C136.957 145.514 134.179 151.352 129.045 151.719Z",
    fill: "#EEA1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.806 134.439C131.934 136.248 125.991 133.402 125.991 133.402C124.684 137.152 120.652 139.497 120.652 139.497L119.834 137.073L120.603 130.742L120.652 130.33L120.972 130.282L132.85 128.536C134.324 130.227 135.341 132.258 135.806 134.439Z",
    fill: "#E07E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.015 129.479C111.825 123.671 115.551 140.498 115.551 140.498C116.274 147.591 110.109 149.338 110.109 149.338C110.109 149.338 98.5141 151.839 109.572 155.468C120.63 159.096 123.135 149.963 121.02 145.742C120.13 143.96 120.311 141.484 120.818 139.217C125.052 136.294 125.015 129.479 125.015 129.479Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.005 141.2C128.005 141.627 127.817 141.973 127.585 141.973C127.354 141.973 127.166 141.627 127.166 141.2C127.166 140.773 127.354 140.427 127.585 140.427C127.817 140.427 128.005 140.773 128.005 141.2Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.795 142.006C135.026 142.006 135.214 141.66 135.214 141.233C135.214 140.806 135.026 140.46 134.795 140.46C134.563 140.46 134.375 140.806 134.375 141.233C134.375 141.66 134.563 142.006 134.795 142.006Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.048 137.849C134.366 137.672 134.729 137.59 135.093 137.612C135.458 137.634 135.808 137.76 136.101 137.975",
    stroke: "#01112C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.901 137.814C126.302 137.552 126.756 137.381 127.232 137.312C127.708 137.244 128.194 137.28 128.654 137.418",
    stroke: "#01112C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.351 141.131C133.597 142.307 133.458 143.53 132.955 144.624",
    stroke: "#01112C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.123 145.955C132.123 145.955 129.173 145.839 127.82 144.451C127.82 144.451 126.284 147.785 128.655 148.574C130.814 149.293 132.123 145.955 132.123 145.955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.831 131.032C122.831 131.032 131.726 134.789 135.589 132.84C139.451 130.891 134.827 127.397 134.827 127.397L125.914 125.616L121.022 128.914L122.831 131.032Z",
    fill: "#01112C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.548 134.951C137.815 132.055 136.104 128.283 132.125 126.457C130.549 125.709 128.832 125.295 127.084 125.241C125.336 125.188 123.596 125.496 121.976 126.147C122.921 125.218 124.16 124.636 125.488 124.497C130.676 123.722 138.788 125.582 139.055 128.907C139.182 130.936 139.011 132.971 138.548 134.951Z",
    fill: "#092E4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1541_19722",
    x1: 183.86,
    y1: 287.497,
    x2: 184.597,
    y2: 110.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#E0ECFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0ECFC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOnDelivery);
export default __webpack_public_path__ + "static/media/cashOnDelivery.119aadfc48bb413f2ff4b1b71e5cee99.svg";
export { ForwardRef as ReactComponent };